module.exports = __webpack_public_path__ + "static/img/6.d1a3448.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/3/1/eng/6.png
// module id = vTc4
// module chunks = 0